import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify);

export default new Vuetify({
lang: {
    locales: { es },
    current: 'es',
  },
  iconfont: 'mdi',
  theme: {
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        azul_med: '#6598C1',
        azulclaro: '#9cbcd7',
        azulfuerte: '#2d567a',
        azulMarino: '#0A0D1E',
        grisClaro: "#cccccc",
        gris: "#666666",
        verde: '#12a14b',
        rojoalert: '#d07575',
      },
    },
  },
});
